import React, { createContext } from 'react';

export const CloudinaryContextType = createContext();
